<template>
    <div class="checkbox-invalid">
        <b-form-group
            class="kyc-status-radio overwrite-radio"
            :label="field.label"
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
        >
            <b-form-checkbox-group
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :options="field.options"
                :name="field._id"
                :disabled="loading"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
            ></b-form-checkbox-group>
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            options: [],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {}, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
}
</script>
